module.exports = __webpack_public_path__ + "media/SanteSocial.cbf0cfca.mp3";